// utils/getSortInfo.ts
import { SorterResult } from "antd/es/table/interface";

import { TableColumnType } from "../types/table";

export type SortOrder = "ascend" | "descend" | undefined;

const stripMinus = (s?: string) => (s?.startsWith("-") ? s.slice(1) : (s ?? ""));

export function getSortOrder(
    columnKey: string,
    sort: string | undefined,
    filterName?: string,
    sortName?: string
): SortOrder {
    if (!sort) return undefined;

    const keyToCheck = sortName ?? filterName ?? columnKey;
    const normalized = stripMinus(sort);

    if (normalized !== keyToCheck) return undefined;
    return sort.startsWith("-") ? "descend" : "ascend";
}

/** ascend  -> "field"
 *  descend -> "-field"
 *  undefined -> undefined
 */
export function getSortParamOnChange<T>(sorter: SorterResult<T>): string | undefined {
    if (!sorter) return undefined;
    const col = sorter.column as TableColumnType<T> | undefined;

    const baseKey =
        col?.sortName ??
        col?.filterName ??
        (typeof sorter.field === "string" ? sorter.field : undefined) ??
        (typeof sorter.columnKey === "string" ? sorter.columnKey : undefined);

    if (!baseKey) return undefined;
    if (sorter.order === "descend") return `-${baseKey}`;
    if (sorter.order === "ascend") return baseKey;
    return undefined; // 3rd click -> undefined
}

/** Helper used by saveSort to know if user explicitly reset sorting */
export function isSorterReset<T>(sorter: SorterResult<T> | SorterResult<T>[] | undefined): boolean {
    const s = Array.isArray(sorter) ? sorter[0] : sorter;
    return Boolean(s && s.order === undefined);
}
